import { apiPost, generateFormData } from "../../../modules/apiHelper";

export default {
  async logUserSession(context, data) {
    const formData = generateFormData(data);

    await apiPost('prog_user_sessions', formData, 76);
  }
};
